import { render } from "./RuleOverviewView.vue?vue&type=template&id=d008f066"
import script from "./RuleOverviewView.vue?vue&type=script&lang=js"
export * from "./RuleOverviewView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/RuleOverviewView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d008f066"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d008f066', __exports__)) {
    api.reload('d008f066', __exports__)
  }
  
  module.hot.accept("./RuleOverviewView.vue?vue&type=template&id=d008f066", () => {
    api.rerender('d008f066', render)
  })

}


export default __exports__